<template>
  <div
    :class="{
      message_cell_ltr: direction == 'ltr',
      message_cell_rtl: direction == 'rtl',
    }"
    :data-info2="userInfo.user_id"
    :data-info1="info.user_id"
  >
    <img
      @click="
        $refs.memberAssetInfoPopup.open(
          info.user.id,
          Number(info.only_my_look) === 1
        )
      "
      class="avatar can"
      :class="{
        avatar_red: info.is_shanghai_msg,
        avatar_green: Number(info.only_my_look) === 1,
      }"
      :src="info.user.avatar"
      alt=""
    />
    <div class="message_info">
      <div class="message_info_header">
        <span class="name" :class="{ name_red: info.is_shanghai_msg }">{{
          info.user.nickname
        }}</span>
        <span class="time">{{ info.createtime_text }}</span>
        <!-- only_my_look=1 时头像变绿色边框，否则显示撤回 -->
        <span
          v-if="info.id && Number(info.only_my_look) === 0"
          @click="delConfirm(info.id)"
          class="time ml5 can"
          style="color: red"
          >撤回</span
        >
        <!-- 新入圈天数，与撤回/仅自己可见并排显示 -->
        <span v-if="info.join_day > 0" class="time ml5 join_day"
          >新入圈{{ info.join_day }}天</span
        >
        <span
          class="live_status"
          v-if="
            id == 'normalChatList' && useSvipList.has(info.user.id + circle_id)
          "
        >
          <!-- useSvipList.includes(info.user.id) -->
          看直播中
        </span>
      </div>
      <!-- 图片类型显示 -->
      <template v-if="info.images && !info.reply_id">
        <div v-if="info.message_type == 'emoji'" class="pr">
          <img class="emoji_image" :src="info.images" alt="" />
          <div v-if="info.send_sus" class="chongshi">
            <div class="chongshi_text" @click="retrySend(info.msg_id)">
              <i class="el-icon-refresh-right" /> 重试
            </div>
          </div>
          <div v-if="info.local" class="loading_img">
            <el-icon><Loading /></el-icon>
            <!-- <img class="imgs" src="@/assets/img/loading.gif" alt="" /> -->
          </div>
          <img
            v-if="reply && !info.local && !info.send_sus"
            class="icon_reply"
            src="@/assets/img/circleV2/icon_reply.png"
            alt=""
            title="引用"
            @click="handleReply"
          />
        </div>
        <div v-else style="position: relative">
          <el-image
            v-for="(item, index) in info.images.split(',')"
            :key="index"
            class="img_360"
            :src="item"
            fit="cover"
            :preview-src-list="info.images.split(',')"
          />
          <div v-if="info.send_sus" class="chongshi">
            <div class="chongshi_text" @click="retrySend(info.msg_id)">
              <i class="el-icon-refresh-right" /> 重试
            </div>
          </div>
          <div v-if="info.local" class="loading_img">
            <el-icon><Loading /></el-icon>
            <!-- <img class="imgs" src="@/assets/img/loading.gif" alt="" /> -->
          </div>
          <img
            v-if="reply && !info.local && !info.send_sus"
            class="icon_reply"
            src="@/assets/img/circleV2/icon_reply.png"
            alt=""
            title="引用"
            @click="handleReply"
          />
        </div>
      </template>
      <!-- 文本类型显示 -->
      <div
        v-else
        class="bubble"
        :class="{ bubble_teacher: isTeacher, bubble_mine: isMine }"
      >
        <div
          v-if="info.reply_id && info.reply_user_nickname"
          class="reply_content"
        >
          <!-- 回复内容显示 非图片 -->
          <div v-if="!info.reply_images" v-html="rePlyContentVal" />
          <!-- 回复内容显示 图片 -->
          <div v-else>
            <div>{{ info.reply_user_nickname }}：</div>
            <el-image
              v-for="(item, index) in info.reply_images.split(',')"
              :key="index"
              class="img_360"
              :src="item"
              fit="cover"
              :preview-src-list="info.reply_images.split(',')"
            />
          </div>
        </div>

        <div v-if="!info.images" class="content" v-html="contentVal" />
        <div v-else>
          <div v-if="info.reply_question" class="huifu_text">
            <img class="icon_da" src="@/assets/img/circleV2/icon_da.png" />
          </div>
          <el-image
            v-for="(item, index) in info.images.split(',')"
            :key="index"
            class="img_360"
            :src="item"
            fit="cover"
            :preview-src-list="info.images.split(',')"
          />
        </div>
        <div v-if="info.send_sus" class="chongshi">
          <div class="chongshi_text" @click="retrySend(info.msg_id)">
            <i class="el-icon-refresh-right" /> 重试
          </div>
        </div>
        <div v-if="info.local" class="loading_img">
          <el-icon><Loading /></el-icon>
          <!-- <img class="imgs" src="@/assets/img/loading.gif" alt="" /> -->
        </div>
        <img
          v-if="reply && !info.local && !info.send_sus"
          class="icon_reply"
          src="@/assets/img/circleV2/icon_reply.png"
          alt=""
          title="引用"
          @click="handleReply"
        />
      </div>
    </div>

    <MemberAssetInfoPopup ref="memberAssetInfoPopup"></MemberAssetInfoPopup>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import MemberAssetInfoPopup from "@/components/MemberAssetInfoPopup.vue";
export default {
  components: {
    MemberAssetInfoPopup,
  },
  props: {
    // isTeacher: {
    //   type: Boolean,
    //   default: false
    // }
    info: {
      type: Object,
      default: Object,
    },
    userInfo: {
      type: Object,
      default: Object,
    },
    id: {
      type: String,
      default: String,
    },
    useSvipList: {
      type: Object,
      default: Object,
    },
    circle_id: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    direction() {
      const info = this.info;
      const userInfo = this.userInfo;
      return userInfo.user_id * 1 === info.user_id * 1 ? "rtl" : "ltr";
    },
    isTeacher() {
      const info = this.info;
      return info.user.is_teacher;
    },
    isMine() {
      const info = this.info;
      const userInfo = this.userInfo;
      return userInfo.user_id === info.user_id;
    },
    rePlyContentVal() {
      const info = this.info;
      let str = `${info.reply_user_nickname}：${this.emojiReplace(
        info.reply_content,
        true
      )}`;
      if (info.reply_question) {
        str =
          `<img class="icon_wen" src="${require("@/assets/img/circleV2/icon_wen.png")}" />` +
          str;
      }
      return str;
    },
    contentVal() {
      const info = this.info;
      let str = this.emojiReplace(info.content);
      if (info.question) {
        str =
          `<img class="icon_wen" src="${require("@/assets/img/circleV2/icon_wen.png")}" />` +
          str;
      } else if (info.user.is_teacher && info.reply_question) {
        str =
          `<img class="icon_da" src="${require("@/assets/img/circleV2/icon_da.png")}" />` +
          str;
      }
      if (info.join_user_id && info.join_user_info) {
        str =
          `欢迎<span class="join_name" data-action="join" data-uid="${
            info.join_user_info.id || info.join_user_id
          }"> @${info.join_user_info.nickname} </span>` + str;
      }
      return str;
    },
    reply() {
      const info = this.info;
      return !(info.reply_question && info.user.is_teacher);
    },
  },
  methods: {
    // 如果后面要给新加入用户添加点击展示资料,就在模板上绑定这个事件
    handleContentClick(e) {
      const target = e.target.closest("[data-action='join']");
      if (!target) return;
      const uid = target.getAttribute("data-uid");
      if (uid) {
        this.$refs.memberAssetInfoPopup.open(uid * 1);
      }
    },
    handleReply() {
      window.dispatchEvent(
        new CustomEvent("circleChatHandleReplay", {
          detail: {
            info: { ...this.info },
          },
          // bubbles: true, // 允许事件冒泡
          // cancelable: true // 允许事件取消
        })
      );
    },
    delConfirm: Debounce(async function (id) {
      this.$confirm("确认撤回该发言吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("deleteMessage", id);
      });
    }),
    retrySend(msgId) {
      this.$emit("retrySend", msgId);
    },
  },
};
</script>

<style scoped>
.message_cell_ltr,
.message_cell_rtl {
  display: flex;
  column-gap: 6px;
}

.message_cell_ltr {
}

.message_cell_rtl {
  flex-direction: row-reverse;
}

.name {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-right: 5px;
}
.name_red {
  color: red;
  font-weight: 600;
}
.time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
.only_my_look {
  color: red;
}
.join_day {
  color: red;
}
.live_status {
  font-size: 10px;
  padding-left: 8px;
  display: inline-flex;
  color: #6bb519;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #eee;
  flex-shrink: 0;
  object-fit: cover;
}
.avatar_red {
  border: 2px solid red;
}
.avatar_green {
  border: 2px solid #6bb519;
}
.message_info {
  max-width: calc(100% - 38px - 50px);
}

.message_cell_rtl .message_info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.message_info_header {
  display: flex;
  margin-bottom: 6px;
}

.bubble {
  position: relative;
  padding: 8px 10px;
  background-color: #fff;
  display: inline-flex;
  flex-direction: column;
}

.bubble_teacher {
  background-color: #dee7ff !important;
}

.bubble_mine {
  background-color: #dee7ff !important;
}

.message_cell_ltr .bubble {
  border-radius: 0px 6px 6px 6px;
}

.message_cell_rtl .bubble {
  border-radius: 6px 0px 6px 6px;
}

.reply_content {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  box-sizing: border-box;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(0, 22, 81, 0.06);
  margin-bottom: 6px;
  text-align: justify;
}

.reply_content >>> p {
  margin: 0;
}
.loading_img {
  position: absolute;
  bottom: 0;
  display: block;
  user-select: none;
  left: -26px;
  width: 16px;
  height: 29px;
  display: flex;
  align-items: center;
}
.loading_img .el-icon {
  animation: loading-rotate 2s linear infinite;
}
@keyframes loading-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loading_img .imgs {
  width: 16px;
  height: 16px;
}
.chongshi {
  position: absolute;
  bottom: 0;
  width: 49px;
  left: -59px;
  display: flex;
  align-items: center;
  height: 29px;
  cursor: pointer;
}
.chongshi_text {
  height: 21px;
  background: #ee3333;
  border-radius: 20px;
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  line-height: 21px;
  width: 49px;
}
.content {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  text-align: justify;
  white-space: pre-line;
  word-break: break-all;
}

.content >>> img {
  /* max-width: 100% !important; */
  max-width: 200px !important;
}

.content >>> p {
  margin: 0;
}

.icon_reply {
  position: absolute;
  bottom: 0;
  width: 22px;
  height: 22px;
  display: block;
  cursor: pointer;
  user-select: none;
}

.message_cell_ltr .icon_reply {
  right: -28px;
}

.message_cell_rtl .icon_reply {
  left: -28px;
}

/deep/.icon_wen,
/deep/.icon_da {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 4px;
  vertical-align: bottom;
}

/deep/.join_name {
  color: #4571e7;
  cursor: pointer;
}

.img_views {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  /* max-width: 225px; */
  opacity: 0;
}

.img_views >>> img {
  max-width: 100% !important;
}

.img_360 {
  width: 210px;
  height: 120px;
  border-radius: 6px;
}

.huifu_text {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.emoji_image {
  width: 140px;
  height: 140px;
  display: block;
}
</style>
